import { DataName, ActionType, ActionUpdateLayerData, SensorNodeStatus, EventReport } from '../../util/model';

type SocketData = SensorNodeStatus | EventReport; 

export const actionUpdateLayerData = (dataName: DataName, data: SocketData): ActionUpdateLayerData => ({
    type: ActionType.UDPATE_LAYER_DATA,
    payload: {
        dataName,
        data
    }
})
